import React, { useState }  from "react";
import "./SecurityVerificationPopup.css";
import { FaShieldAlt } from "react-icons/fa";

const availableCards = [
  { src: "/new-img/cards/visa.svg", alt: "VISA" },
  { src: "/new-img/cards/mastercard.svg", alt: "MASTERCARD" },
  { src: "/new-img/cards/amex.svg", alt: "AMEX" },
  { src: "/new-img/cards/discover.svg", alt: "DISCOVER" },
  { src: "/new-img/cards/jcb.svg", alt: "JCB" },
  { src: "/new-img/cards/diners_club.svg", alt: "DINERS" },
  { src: "/new-img/cards/unionpay.svg", alt: "UNIONPAY" },
  { src: "/new-img/cards/elo.svg", alt: "ELO" },
];
function getCardSrcByAlt(alt) {
  const card = availableCards.find(c => c.alt.toLowerCase() == alt.toLowerCase());
  return card ? card.src : null;
}

const SecurityVerificationPopup = ({ visible, onConfirm, onCancel, setStatusMessage, securityVerificationCardName }) => {
  const [cardSrc, setCardSrc] = useState(getCardSrcByAlt(securityVerificationCardName))

  if (!visible) return null;  
  return (
    <div className="security-verify-overlay">
      <div className="security-verify-popup">
        <div className="svp-icons">
          <img src="/new-img/minimal-logo.webp" alt='PuppySpot' className="svp-card-icon" />
          <img src={cardSrc} alt={securityVerificationCardName} className="svp-card-icon" />
        </div>
        <h3>Additional Verification Required</h3>
        <p>
          For your protection, your bank requires extra verification before continuing.
        </p>
        <div className="security-verify-buttons">
          <button className="btn-confirm" onClick={onConfirm}>
            Proceed
          </button>
          <button className="btn-cancel" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default SecurityVerificationPopup;
